/**
 * @name FiltersService
 * @description Servicio de filtros para modificar el formato de texto, fecha o elemento de React
 * @author Ricardo Guerra
 */

import React from 'react';
import i18n from 'i18next';
import moment from 'moment';
import styled from 'styled-components';

import { DownloadFileService } from '@services';
import { Avatar, Icons, Theme, Typography } from '@styles';

const ActiveFilter = (item) => {
  return item ? i18n.t('StatusText.active') : i18n.t('StatusText.inactive');
};

const ActiveIconFilter = (item) => {
  return item ? (
    <IconBox>
      <Icons.Check style={{ color: Theme.colors.green }} />
    </IconBox>
  ) : (
    <IconBox>
      <Icons.Remove style={{ color: Theme.colors.red }} />
    </IconBox>
  );
};

const AvatarFilter = (url) => {
  return (
    <Avatar
      size="xs"
      src={url ? url : 'https://assets.talentry.io/icons/profile/TAL_Avatar.png'}
    />
  );
};

const ShortDateFilter = (item) => {
  return item === '0001-01-01T00:00:00' ? '' : moment(item).format(i18n.t('FormatDates.short'));
};

const BirthdayDateFilter = (item) => {
  return moment(item).format(i18n.t('FormatDates.birthday'));
};

const MonthNameFilter = (item) => {
  const monthsName = [
    i18n.t('Months.jan'),
    i18n.t('Months.feb'),
    i18n.t('Months.mar'),
    i18n.t('Months.apr'),
    i18n.t('Months.may'),
    i18n.t('Months.jun'),
    i18n.t('Months.jul'),
    i18n.t('Months.aug'),
    i18n.t('Months.sep'),
    i18n.t('Months.oct'),
    i18n.t('Months.nov'),
    i18n.t('Months.dec')
  ];
  return monthsName[item - 1];
};

const YesNoFilter = (item) => {
  return item ? i18n.t('StatusText.yes') : i18n.t('StatusText.no');
};

const Time12HoursFilter = (item) => {
  return moment(item, 'hh:mm:ss').format('hh:mm A');
};

// Servicio para realizar la descarga
const downloadFile = (data, event) => {
  DownloadFileService.download(data);
}

const DownloadFileFilter = (item, flag) => {
  return (
    item ? (
      <Typography.TextLink onClick={flag ? (event) => downloadFile(item, event) : null} >
        {i18n.t('UploadFile.downloadFile')}
      </Typography.TextLink>
    ) : ''
  );
};

// Filtro para los id's de buzón de denuncias.
const IdComplaintFilter = (item) => {
  return (
    item ? (
      <Typography.TextLink target="_blank" rel="noopener noreferrer">
        {item}
      </Typography.TextLink>
    ) : ''
  );
};

// Filtro para los estatus de buzón de denuncias. 
const StatusComplaintFilter = (item) => {
  if (item === 1) { // Pendiente
    return (<StatusPending>{i18n.t('StatusText.pending')}</StatusPending>);
  }
  else if (item === 2) { // En revisión
    return (<StatusInReview>{i18n.t('StatusText.inRevision')}</StatusInReview>);
  }
  else if (item === 3) { // Concluído
    return (<StatusConcluded>{i18n.t('StatusText.concluded')}</StatusConcluded>);
  }
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const IconBox = styled.div`
  height: 20px;
  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

const StatusBox = styled.span`
  padding: 4px;
  border-radius: 6px;
`;

const StatusPending = styled(StatusBox)`
  color: ${(props) => props.theme.colors.greyDark};
  background-color: ${(props) => props.theme.colors.greyLight};
`;

const StatusInReview = styled(StatusBox)`
  color: ${(props) => props.theme.colors.blueDark};
  background-color: #0076A840; // Blue Dark (25%)
`;

const StatusConcluded = styled(StatusBox)`
  color: ${(props) => props.theme.colors.green};
  background-color: #00AF7740; // Green (25%)
`;

export const FiltersService = {
  ActiveFilter,
  ActiveIconFilter,
  AvatarFilter,
  ShortDateFilter,
  BirthdayDateFilter,
  MonthNameFilter,
  YesNoFilter,
  Time12HoursFilter,
  DownloadFileFilter,
  IdComplaintFilter,
  StatusComplaintFilter
};